import Distractions from '~/pages/anatomy/distractions/libs/components/Distractions'
import { TPageProps } from '~/shared/types/commonTypes'

const DistractionsAnatomy = ({ nextPagePath, pageId }: TPageProps) => (
  <Distractions nextPagePath={nextPagePath} pageId={pageId} />
)

export default DistractionsAnatomy
